import { Form, Input, Select } from 'antd';
import { AreaEnum, IMobileRef, IPOAccount, IPOMessage, IPOModal, IPOSelect, IPOUtils, MobileInput } from '../../..';
import React, { FC, ReactNode, useEffect, useRef } from 'react';

interface IStaffAddProps {
	isShowAdd: boolean;
	AddUserReq: (staff: IPOAccount.IAddStaff) => Promise<void>;
	handleChange: () => void;
	uploadEle: ReactNode;
	showRight?: boolean;
}

export const AddStaff: FC<IStaffAddProps> = ({ isShowAdd, AddUserReq, handleChange, uploadEle, showRight }) => {
	showRight = showRight ?? false
	const { Option } = Select;
	const mobileRef = useRef<IMobileRef>();
	
	const [addForm] = Form.useForm();

	useEffect(() => {
		if(!isShowAdd) {
			addForm.resetFields()
			uploadEle = null
		}
	}, [isShowAdd])

	const handleAddStaff: () => void = () => {
		const mobileValidate = mobileRef.current?.getValidateRes()

		if (mobileValidate) {
			const addParams = {
				name: addForm.getFieldValue('name') ?? '',
				name2: addForm.getFieldValue('name2') ?? '',
				email: addForm.getFieldValue('email') ?? '',
				avatar: addForm.getFieldValue('avatar') ?? '',
				role: addForm.getFieldValue('role') ?? IPOAccount.StaffRoleEnum.CUSTOM,
				areaCode: mobileValidate.mobileInfo.areaCode,
				mobile: mobileValidate.mobileInfo.phoneNum,
			}

			IPOUtils.regAccount(addParams)
				.then(() => {
					AddUserReq(addParams).then(() => {
						IPOMessage.success('添加成功')
						handleChange()
					})
				})
		}
	}

	return (
		<IPOModal
			title='添加员工'
			isShowPadding
			visible={isShowAdd}
			okText='确定'
			cancelText='取消'
			onOk={() => handleAddStaff()}
			onCancel={() => handleChange()}
			getContainer={false}
			maskClosable={false}
		>
			<Form form={addForm} colon={false} labelCol={{ span: 3, offset: 0 }} >
				<Form.Item
					label="头像"
					name="avatar">
					{uploadEle}
				</Form.Item>
				<Form.Item label="英文名" name="name" >
					<Input />
				</Form.Item>
				<Form.Item label="中文名" name="name2" >
					<Input />
				</Form.Item>
				<Form.Item
					label="手机号"
					name="mobile"
					rules={[{ required: true, message: '请输入手机号' }]}>
					<MobileInput mobileRef={mobileRef} mobileInfo={{ areaCode: AreaEnum.HK, phoneNum: '' }} data-allowClear={false}/>
				</Form.Item>
				<Form.Item label="邮箱" name="email" >
					<Input />
				</Form.Item>
				{
					showRight &&
					<Form.Item
						label="权限"
						name="role"
						rules={[{ required: true, message: 'Please input your username!' }]}>
						<IPOSelect defaultValue={0} style={{ width: '100%' }} onChange={() => { }}>
							<Option value={0}>普通权限</Option>
							<Option value={1}>高级权限</Option>
							<Option value={2}>监管方权限</Option>
						</IPOSelect>
					</Form.Item>
				}
			</Form>
		</IPOModal>
	);
};